module.exports = __webpack_public_path__ + "img/L7.a2e2064.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cooperation/banner/L7.png
// module id = mu7w
// module chunks = 0